import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import invoiceSupplierService from "../services/invoiceSupplierService";
const initialState = {
    invoices: [],
    invoicesSummary: [],
    payments: [],
    lastSavedInvoice: null,
    loading: false,
    loadingPayment: false,
    error: null,
    invoiceNumber: null,
    totalElements: 0, // Total number of records
    totalPages: 0, // Total number of pages
    pageNumber: 0, // Current page number
    pageSize: 6, // Size of each page
    totalAmountTtc: 0,
    totalAmountHt: 0,// Add this field
    dateFrom: null,
    dateTo: null,

};

const invoiceSupplierSlice = createModule({
    name: 'invoiceSupplier',
    initialState,
    reducers: {
        generatePdfRequest: (state) => {
            state.loading = true;
        },
        search: (state) => {
            state.loading = true;
        },
        searchInvoiceSummary: (state) => {
            state.loading = true;
        },
        filterInvoice: (state, action) => {
            state.loading = true;
        },
        generateReleveRequest: (state) => {
            state.loading = true;
        },
        generateReleveSuccess: (state) => {
            state.loading = false;
        },
        generateReleveFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        fetchPayments: (state) => {
            state.loadingPayment = true;
        },
        createInvoice: (state) => {
            state.loading = true;
        },
        addPayment: (state) => {
            state.loadingPayment = true;
        },
        deleteInvoice: (state) => {
            state.loading = true;
        },
        lastSaved: (state) => {
            state.loading = true;
        },
        fetchNewInvoiceNumber: (state) => {
            state.loading = true;
        },
        fetchedData: (state, payload) => {
            state.loading = false;
            state.invoices = payload.body;
        },
        fetchedPaymentsData: (state, payload) => {
            state.loadingPayment = false;
            state.payments = payload.body.content;
            state.totalElements = payload.body.totalElements; // Assuming totalElements is in payload
            state.totalPages = payload.body.totalPages; // Assuming totalPages is in payload
            state.pageNumber = payload.body.pageNumber;
            state.totalAmountTtc = payload.body.totalAmountTtc;
            state.dateFrom = payload.body.dateFrom;
            state.dateTo = payload.body.dateTo;
        },
        fetchedInvoiceNumber: (state, action) => {
            state.loading = false;
            state.invoiceNumber = action;
        },
        finishFetching: (state) => {
            state.loading = false;
            state.loadingPayment = false;
        },
        fetchError: (state, action) => {
            state.loading = false;
            state.error = action.payload || "An error occurred";
        },
        generatePdfSuccess: (state) => {
            state.loading = false;
        },
        generatePdfFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        deleteInvoiceSuccess: (state, action) => {
            state.loading = false;
            state.invoices = state.invoices.filter(invoice => invoice.id !== action.id);
        },
        deleteInvoiceFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        fetchedSummaryData: (state, action) => {
            state.loading = false;
            state.invoicesSummary = action.body.content;
            state.totalElements = action.body.totalElements; // Assuming totalElements is in payload
            state.totalPages = action.body.totalPages; // Assuming totalPages is in payload
            state.pageNumber = action.body.pageNumber;
            state.totalAmountTtc = action.body.totalAmountTtc;
        },
        updateInvoice: (state) => {
            state.loading = true;
        },
        updateInvoiceSuccess: (state, action) => {
            state.loading = false;
            const index = state.invoices.findIndex(invoice => invoice.id === action.payload.id);
            if (index !== -1) {
                state.invoices[index] = action.payload;
            }
        },
        updateInvoiceFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },

    },
    sagas: (A) => ({
        *[A.search]({ payload }) {
            try {
                console.log(payload);
                const data = yield call(invoiceSupplierService.search, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.searchInvoiceSummary]({ payload }) {
            try {
                const {data} = yield call(invoiceSupplierService.searchInvoiceSummary, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedSummaryData(data));
            }
            catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.fetchPayments]({ payload }) {
            try {
                const {data} = yield call(invoiceSupplierService.searchPayments, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedPaymentsData(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.filterInvoice]({ payload }) {
            try {
                console.log(payload);
                const { data } = yield call(invoiceSupplierService.filterInvoice, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.createInvoice]({ payload }) {
            try {
                console.log(payload);
                const {data} = yield call(invoiceSupplierService.addInvoice, payload.invoice);
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data);
                // yield put(A.fetchedData(data)); // Dispatch the action to update the state with the new invoice
                // yield put(A.generatePdfRequest(data.data.body)); // Dispatch the action to generate the PDF after invoice creation
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
                payload.onError(e);
            }
        },
        *[A.addPayment]({ payload }) {
            try {
                console.log(payload);
                const { data } = yield call(invoiceSupplierService.addPayment, payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data);
            } catch (e) {
                yield put(A.finishFetching());
                yield call(payload.onError());
                yield put(A.fetchError());
            }
        },
        *[A.generatePdfRequest]({ payload }) {
            try {
                const pdfData = yield call(invoiceSupplierService.generateDocument, payload);
                const blob = new Blob([pdfData], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                window.open(url, '_blank'); // Open the PDF in a new window
                yield put(A.generatePdfSuccess());
            } catch (error) {
                yield put(A.generatePdfFailure(error.message));
            }
        },
        *[A.generateReleveRequest]({ payload }) {
            try {
                const pdfData = yield call(invoiceSupplierService.generateReleve, payload);
                const blob = new Blob([pdfData], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                window.open(url, '_blank'); // Open the PDF in a new window
                yield put(A.generatePdfSuccess());
            } catch (error) {
                yield put(A.generatePdfFailure(error.message));
            }
        },
        *[A.deleteInvoice]({ payload }) {
            try {
                yield call(invoiceSupplierService.deleteInvoice, payload.id);
                yield put(A.deleteInvoiceSuccess(payload));
                payload.onSuccess();
            } catch (e) {
                console.log(e);
                yield put(A.deleteInvoiceFailure(e.message));
            }
        },
        *[A.lastSaved]({ payload }) {
            try {
                const { data } = yield call(invoiceSupplierService.getLastSavedInvoice);
                yield put(A.fetchedData(data));
                payload.onSuccess(data);

            } catch (e) {
                console.log(e);
                yield put(A.fetchError(e.message));
            }
        },
        *[A.updateInvoice]({ payload }) {
            try {
                const data = yield call(invoiceSupplierService.updateInvoice, payload.invoice.id, payload.invoice);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.fetchNewInvoiceNumber]() {
            try {
                const { data } = yield call(invoiceSupplierService.getNewInvoiceNumber);
                yield put(A.finishFetching());
                yield put(A.fetchedInvoiceNumber(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
    }),

});

export default invoiceSupplierSlice;
export const invoiceSupplierActions = invoiceSupplierSlice.actions;